import styled from "styled-components";

const NoContent = styled.div`
    color: var(--color-grey-lighter);
    ${props => props.css}
`;

export default NoContent;